<div>
  <app-user-basic
    [user]="tableRowData[tableCellAttribute.key]"
    [srtIndex]="rowIndex + '-' + cellIndex"
    [hasTableSizeLimit]="true"
    [redirectToLoginIfNoSession]="redirectToLoginIfNoSession"
  ></app-user-basic>
</div>
